import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-zoom-out",
  "use": "icon-s-zoom-out-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-zoom-out\"><defs><clipPath id=\"icon-s-zoom-out_a\"><path d=\"M9 0a9 9 0 0 1 7.032 14.618l5.675 5.675a1 1 0 0 1-1.414 1.414l-5.675-5.675A9 9 0 1 1 9 0m0 2a7 7 0 1 0 0 14A7 7 0 0 0 9 2m4 6a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2z\" /></clipPath></defs><g clip-path=\"url(#icon-s-zoom-out_a)\"><path d=\"M0 0h21.987v21.988H0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol